import type { LessonNode } from "@/api/recommendedAssignments";

// These are all the lessons from https://help.securityjourney.com/knowledge/post-assessment-training-recommendations
// We generated this on 3:30 PM EST on 06/09/2025
// If you need to update this, do the following:

/**
  STEP 1: Get all lessonIDs from this link https://help.securityjourney.com/knowledge/post-assessment-training-recommendations
    I copied the HTML and grabbed all the href's from the a tags, then did some vscode magic to extract the lesson IDs

  STEP 2: Pull up the Production rails DB (securityjourney) and run the query below (with the lesson IDs you pulled)
    select lesson_key, l.id from lesson_groups lg join lessons l on l.lesson_group_id = lg.id where l.id in(LESSON_IDS_HERE)
 */

const secureCodingLessonsForTree = {
  id: "secure-coding-lessons",
  key: "secure-coding-lessons",
  label: "Secure Coding",
  children: [
    {
      id: "authentication-and-authorization-issues",
      key: "authentication-and-authorization-issues",
      label: "Authentication and Authorization Issues",
      children: [
        {
          id: 1188,
          key: "cwe287-improper-authn__a",
          label: "CWE-287 Improper Authentication",
          lesson_key: "cwe287-improper-authn",
          isDuplicate: true,
          lessonType: "video",
        },
        {
          id: 1067,
          key: "api-bauth",
          label: "Broken Authentication",
          lesson_key: "api-bauth",
          lessonType: "breakfix",
        },
        {
          id: 1195,
          key: "cwe798-use-of-hardcoded-credentials__a",
          label:
            "CWE-798 Use of Hard-Coded Credentials, Cryptographic Failures | Use of Hard-Coded Password (Part 1)",
          lesson_key: "cwe798-use-of-hardcoded-credentials",
          isDuplicate: true,
          lessonType: "video",
        },
        {
          id: 935,
          key: "was1-secrets-1",
          label: "Cryptographic Failures | Use of Hard-Coded Password (Part 1)",
          lesson_key: "was1-secrets-1",
          isDuplicate: true,
          lessonType: "breakfix",
        },
        {
          id: 943,
          key: "was1-secrets-2__a",
          label: "Cryptographic Failures | Use of Hard-Coded (Part 2)",
          lesson_key: "was1-secrets-2",
          isDuplicate: true,
          lessonType: "breakfix",
        },
      ],
    },
    {
      id: "concurrency-isses",
      key: "concurrency-isses",
      label: "Concurrency Issues",
      children: [
        {
          id: 923,
          key: "secure-coding-for-embedded-systems-part-1",
          label: "Secure Coding Techniques for Embedded Systems | Part 1",
          lesson_key: "secure-coding-for-embedded-systems-part-1",
          lessonType: "video",
        },
      ],
    },
    {
      id: "design-and-configuration-flaws",
      key: "design-and-configuration-flaws",
      label: "Design and Configuration Flaws",
      children: [
        {
          id: 1182,
          key: "c-i-l-o-a-p-to-a-restricted-directory-path-traversal",
          label:
            "CWE-22 Improper Limitation of a Pathname to a Restricted Directory ('Path Traversal')",
          lesson_key: "c-i-l-o-a-p-to-a-restricted-directory-path-traversal",
          lessonType: "video",
        },
        {
          id: 821,
          key: "was1-path-trav",
          label: "Path Traversal (CWE-22)",
          lesson_key: "was1-path-trav",
          lessonType: "breakfix",
        },
      ],
    },
    {
      id: "data-processing-issues",
      key: "data-processing-issues",
      label: "Data Processing Issues",
      children: [
        {
          id: 1196,
          key: "cwe190-integer-overflow-or-wraparound",
          label: "CWE-190 Integer Overflow or Wraparound",
          lesson_key: "cwe190-integer-overflow-or-wraparound",
          lessonType: "video",
        },
      ],
    },
    {
      id: "improper-access-control",
      key: "improper-access-control",
      label: "Improper Access Control",
      children: [
        {
          id: 1178,
          key: "cwe862-missing-authz",
          label: "CWE-862 Missing Authorization",
          lesson_key: "cwe862-missing-authz",
          lessonType: "video",
        },
        {
          id: 1034,
          key: "was1-bac-v1",
          label: "Broken Access Control | Improper Access Control",
          lesson_key: "was1-bac-v1",
          lessonType: "breakfix",
        },
      ],
    },
    {
      id: "injection-flaws",
      key: "injection-flaws",
      label: "Injection Flaws",
      children: [
        {
          id: 1185,
          key: "cwe94-improper-control-of-generation-of-code-code-i",
          label: "CWE-94 Improper Control of Generation of Code ('Code Injection')",
          lesson_key: "cwe94-improper-control-of-generation-of-code-code-i",
          lessonType: "video",
        },
        {
          id: 1033,
          key: "was1-cmdi-v2",
          label: "Command Injection (CWE-78 -- OS Command Injection)",
          lesson_key: "was1-cmdi-v2",
          lessonType: "breakfix",
        },
      ],
    },
    {
      id: "owasp-injection",
      label: "OWASP Injection",
      key: "owasp-injection",
      children: [
        {
          id: 1180,
          key: "c-i-n-of-special-elements-used-in-an-sql-comma-sql-i",
          label:
            "CWE-89 Improper Neutralization of Special Elements used in an SQL Command ('SQL Injection')",
          lesson_key: "c-i-n-of-special-elements-used-in-an-sql-comma-sql-i",
          lessonType: "video",
        },
        {
          id: 1030,
          key: "was1-sqli-1",
          label: "SQL Injection: Part 1",
          lesson_key: "was1-sqli-1",
          lessonType: "breakfix",
        },
        {
          id: 1038,
          key: "was1-sqli-2",
          label: "SQL Injection: Part 2",
          lesson_key: "was1-sqli-2",
          lessonType: "breakfix",
        },
        {
          id: 1032,
          key: "was1-sqli-3",
          label: "SQL Injection: Part 3",
          lesson_key: "was1-sqli-3",
          lessonType: "breakfix",
        },
      ],
    },
    {
      id: "owasp-security-logging-and-monitoring-failures",
      label: "OWASP Security Logging and Monitoring Failures",
      key: "owasp-security-logging-and-monitoring-failures",
      children: [
        {
          id: 773,
          key: "logging-and-exception-handling",
          label: "Logging and Exception Handling",
          lesson_key: "logging-and-exception-handling",
          lessonType: "video",
        },
        {
          id: 934,
          key: "was1-slmf-v1",
          label: "Security Logging and Monitoring Failures | Insufficient Logging",
          lesson_key: "was1-slmf-v1",
          lessonType: "breakfix",
        },
      ],
    },
    {
      id: "owasp-server-side-request-forgery",
      label: "OWASP Server-Side Request Forgery",
      key: "owasp-server-side-request-forgery",
      children: [
        {
          id: 1192,
          key: "cwe918-serverside-request-forgery-ssrf",
          label: "CWE-918 Server-Side Request Forgery (SSRF)",
          lesson_key: "cwe918-serverside-request-forgery-ssrf",
          lessonType: "video",
        },
        {
          id: 612,
          key: "was1-ssrf",
          label: "Server-Side Request Forgery (SSRF)",
          lesson_key: "was1-ssrf",
          lessonType: "breakfix",
        },
      ],
    },
    {
      id: "owasp-software-and-data-integrity-failures",
      label: "OWASP Software and Data Integrity Failures",
      key: "owasp-software-and-data-integrity-failures",
      children: [
        {
          id: 1187,
          key: "cwe502-deser-of-untrusted-data",
          label: "CWE-502 Deserialization of Untrusted Data",
          lesson_key: "cwe502-deser-of-untrusted-data",
          lessonType: "video",
        },
        {
          id: 1039,
          key: "was1-sdif-v1",
          label: "Software and Data Integrity Failures | Overreliance on Cookies",
          lesson_key: "was1-sdif-v1",
          lessonType: "breakfix",
        },
      ],
    },
    {
      id: "owasp-vulnerable-and-outdated-components",
      label: "OWASP Vulnerable and Outdated Components",
      key: "owasp-vulnerable-and-outdated-components",
      children: [
        {
          id: 777,
          key: "software-supply-chain__a",
          label: "Software Supply Chain",
          lesson_key: "software-supply-chain",
          isDuplicate: true,
          lessonType: "video",
        },
        {
          id: 955,
          key: "devsecops-dependency-management-v1",
          label: "Vulnerable and Outdated Components | Using Components with Known Vulnerabilities",
          lesson_key: "devsecops-dependency-management-v1",
          lessonType: "breakfix",
        },
      ],
    },
    {
      id: "owasp-security-misconfiguration",
      key: "owasp-security-misconfiguration",
      label: "OWASP Use of Hard-Coded Credentials",
      children: [
        {
          id: 1195,
          key: "cwe798-use-of-hardcoded-credentials__b",
          label: "CWE-798 Use of Hard-coded Credentials",
          lesson_key: "cwe798-use-of-hardcoded-credentials",
          isDuplicate: true,
          lessonType: "video",
        },
        {
          id: 935,
          key: "was1-secrets-1",
          label: "Cryptographic Failures | Use of Hard-coded Password (Part 1)",
          lesson_key: "was1-secrets-1",
          isDuplicate: true,
          lessonType: "breakfix",
        },
        {
          id: 943,
          key: "was1-secrets-2__b",
          label: "Cryptographic Failures | Use of Hard-coded Password (Part 2)",
          lesson_key: "was1-secrets-2",
          isDuplicate: true,
          lessonType: "breakfix",
        },
      ],
    },
    {
      id: "owasp-insecure-design",
      key: "owasp-insecure-design",
      label: "OWASP Insecure Design",
      children: [
        {
          id: 623,
          key: "was1-idesi",
          label: "Insecure Design",
          lesson_key: "was1-idesi",
          lessonType: "breakfix",
        },
      ],
    },
    {
      id: "owasp-security-misconfiguration",
      key: "owasp-security-misconfiguration",
      label: "OWASP Security Misconfiguration",
      children: [
        {
          id: 1071,
          key: "was1-secmisc",
          label: "Security Misconfigurations | Error Message Containing Sensitive Information",
          lesson_key: "was1-secmisc",
          lessonType: "breakfix",
        },
      ],
    },
    {
      id: "owasp-identification-and-authentication-failures",
      key: "owasp-identification-and-authentication-failures",
      label: "OWASP Identification and Authentication Failures",
      children: [
        {
          id: 1188,
          label: "CWE-287 Improper Authentication",
          key: "cwe287-improper-authn__b",
          lesson_key: "cwe287-improper-authn",
          isDuplicate: true,
          lessonType: "video",
        },
      ],
    },
  ],
};

const coreSecurityConceptsLessonsForTree = {
  id: "core-security-concepts-lessons",
  key: "core-security-concepts-lessons",
  label: "Core Security Concepts",
  children: [
    {
      id: "attack-terminology",
      label: "Attack Terminology",
      key: "attack-terminology",
      children: [
        {
          id: 1153,
          key: "introduction-to-security",
          label: "Introduction to Security",
          lesson_key: "introduction-to-security",
          lessonType: "video",
        },
        {
          id: 919,
          key: "data-breaches__a",
          label: "Data Breaches",
          lesson_key: "data-breaches",
          isDuplicate: true,
          lessonType: "video",
        },
        {
          id: 892,
          key: "attacks",
          label: "Attacks",
          lesson_key: "attacks",
          lessonType: "video",
        },
        {
          id: 916,
          key: "knowledge-sources__a",
          label: "Knowledge Sources",
          lesson_key: "knowledge-sources",
          isDuplicate: true,
          lessonType: "video",
        },
      ],
    },
    {
      id: "application-and-product-security",
      label: "Application and Product Security",
      key: "application-and-product-security",
      children: [
        {
          id: 912,
          key: "core-security-concepts__a",
          label: "Core Security Concepts",
          lesson_key: "core-security-concepts",
          isDuplicate: true,
          lessonType: "video",
        },
        {
          id: 800,
          key: "six-foundational-truths-of-application-security",
          label: "Six Foundational Truths of Application Security",
          lesson_key: "six-foundational-truths-of-application-security",
          lessonType: "video",
        },
        {
          id: 777,
          key: "software-supply-chain__b",
          label: "Software Supply Chain",
          lesson_key: "software-supply-chain",
          isDuplicate: true,
          lessonType: "video",
        },
      ],
    },
    {
      id: "data-privacy",
      label: "Data Privacy",
      key: "data-privacy",
      children: [
        {
          id: 911,
          key: "privacy-and-customer-data-protection",
          label: "Privacy and Customer Data Protection",
          lesson_key: "privacy-and-customer-data-protection",
          lessonType: "video",
        },
        {
          id: 801,
          key: "introduction-to-linddun",
          label: "LINDDUN Privacy Threat Modeling",
          lesson_key: "introduction-to-linddun",
          lessonType: "video",
        },
      ],
    },
    {
      id: "cia-security-triad",
      label: "CIA Security Triad",
      key: "cia-security-triad",
      children: [
        {
          id: 912,
          key: "core-security-concepts__b",
          label: "Core Security Concepts",
          lesson_key: "core-security-concepts",
          isDuplicate: true,
          lessonType: "video",
        },
      ],
    },
    {
      id: "threat-actors",
      label: "Threat Actors",
      key: "threat-actors",
      children: [
        {
          id: 914,
          key: "attackers",
          label: "Attackers",
          lesson_key: "attackers",
          lessonType: "video",
        },
        {
          id: 897,
          key: "social-engineering__a",
          label: "Social Engineering",
          lesson_key: "social-engineering",
          isDuplicate: true,
          lessonType: "video",
        },
      ],
    },
    {
      id: "security-organization-and-community",
      label: "Security Organization and Community",
      key: "security-organization-and-community",
      children: [
        {
          id: 894,
          key: "prioritizing-security",
          label: "Prioritizing Security",
          lesson_key: "prioritizing-security",
          lessonType: "video",
        },
        {
          key: "translating-security",
          label: "Translating Security",
          id: 929,
          lesson_key: "translating-security",
          lessonType: "video",
        },
        {
          id: 930,
          key: "myths",
          label: "Security Myths",
          lesson_key: "myths",
          lessonType: "video",
        },
        {
          id: 891,
          key: "owasp-universe",
          label: "OWASP Universe",
          lesson_key: "owasp-universe",
          lessonType: "video",
        },
        {
          id: 916,
          key: "knowledge-sources__b",
          label: "Knowledge Sources",
          lesson_key: "knowledge-sources",
          isDuplicate: true,
          lessonType: "video",
        },
      ],
    },
    {
      id: "risk-terminology",
      label: "Risk Terminology",
      key: "risk-terminology",
      children: [
        {
          id: 917,
          key: "risk-management-for-appsec",
          label: "Risk Management for AppSec",
          lesson_key: "risk-management-for-appsec",
          lessonType: "video",
        },
      ],
    },
    {
      id: "threat-terminology",
      label: "Threat Terminology",
      key: "threat-terminology",
      children: [
        {
          id: 902,
          key: "threat-landscape__a",
          label: "Threat Landscape",
          lesson_key: "threat-landscape",
          isDuplicate: true,
          lessonType: "video",
        },
        {
          id: 895,
          key: "threat-landscape-cloud",
          label: "Threat Landscape: Cloud",
          lesson_key: "threat-landscape-cloud",
          lessonType: "video",
        },
      ],
    },
    {
      id: "security-champions",
      label: "Security Champions",
      key: "security-champions",
      children: [
        {
          id: 1154,
          key: "culture-and-mindset",
          label: "Security Culture and Mindset",
          lesson_key: "culture-and-mindset",
          lessonType: "video",
        },
      ],
    },
    {
      id: "proactive-security",
      label: "Proactive Security",
      key: "proactive-security",
      children: [
        {
          id: 918,
          key: "security-business-case",
          label: "Security Business Case",
          lesson_key: "security-business-case",
          lessonType: "video",
        },
      ],
    },
    {
      id: "security-threats-and-impact",
      label: "Security Threats and Impact",
      key: "security-threats-and-impact",
      children: [
        {
          id: 902,
          key: "threat-landscape__b",
          label: "Threat Landscape",
          lesson_key: "threat-landscape",
          isDuplicate: true,
          lessonType: "video",
        },
        {
          id: 778,
          key: "denial-of-service",
          label: "Denial of Service (DoS)",
          lesson_key: "denial-of-service",
          lessonType: "video",
        },
        {
          id: 897,
          key: "social-engineering__b",
          label: "Social Engineering",
          lesson_key: "social-engineering",
          isDuplicate: true,
          lessonType: "video",
        },
        {
          id: 919,
          key: "data-breaches__b",
          label: "Data Breaches",
          lesson_key: "data-breaches",
          isDuplicate: true,
          lessonType: "video",
        },
      ],
    },
  ],
};

const secureDevelopmentAndDesignLessonsForTree = {
  id: "secure-development-&-design",
  key: "secure-development-&-design",
  label: "Secure Development & Design",
  children: [
    {
      id: "devsecops-build-and-deployment",
      label: "DevSecOps - Build and Deployment",
      key: "devsecops-build-and-deployment",
      children: [
        {
          id: 421,
          key: "devsecops-maturity-model-build-deployment",
          label: "DevSecOps Maturity Model Build - Deployment",
          lesson_key: "devsecops-maturity-model-build-deployment",
          lessonType: "video",
        },
      ],
    },
    {
      id: "devsecops-culture-and-organization",
      label: "DevSecOps - Culture and Organization",
      key: "devsecops-culture-and-organization",
      children: [
        {
          id: 502,
          key: "devsecops-maturity-model-culture-org",
          label: "DevSecOps Maturity Model Build - Culture - Organization",
          lesson_key: "devsecops-maturity-model-culture-org",
          lessonType: "video",
        },
      ],
    },
    {
      id: "devsecops-implementation",
      label: "DevSecOps - Implementation",
      key: "devsecops-implementation",
      children: [
        {
          id: 422,
          key: "devsecops-maturity-model-info-part-1",
          label: "DevSecOps Maturity Model Implementation - Information Gathering part 1",
          lesson_key: "devsecops-maturity-model-info-part-1",
          lessonType: "video",
        },
      ],
    },
    {
      id: "devsecops-information-gathering",
      label: "DevSecOps - Information Gathering",
      key: "devsecops-information-gathering",
      children: [
        {
          id: 423,
          key: "devsecops-maturity-model-info-part-2__a",
          label: "DevSecOps Maturity Model Implementation - Information Gathering part 2",
          lesson_key: "devsecops-maturity-model-info-part-2",
          isDuplicate: true,
          lessonType: "video",
        },
      ],
    },
    {
      id: "devsecops-test-and-verification",
      label: "DevSecOps - Test and Verification",
      key: "devsecops-test-and-verification",
      children: [
        {
          id: 424,
          key: "devsecops-maturity-model-test-verification-part-1",
          label: "DevSecOps Maturity Model Test - Verification part 1",
          lesson_key: "devsecops-maturity-model-test-verification-part-1",
          lessonType: "video",
        },
        {
          id: 487,
          key: "maturity-model-test-verification-part-2",
          label: "DevSecOps Maturity Model Test Verification part 2",
          lesson_key: "maturity-model-test-verification-part-2",
          lessonType: "video",
        },
      ],
    },
    {
      id: "sdlc-metrics-and-reporting",
      label: "SDLC - Metrics and Reporting",
      key: "sdlc-metrics-and-reporting",
      children: [
        {
          id: 896,
          key: "secure-development-lifecycle__a",
          label: "Secure Development Lifecycle",
          lesson_key: "secure-development-lifecycle",
          isDuplicate: true,
          lessonType: "video",
        },
        {
          id: 423,
          key: "devsecops-maturity-model-info-part-2__b",
          label: "DevSecOps Maturity Model Implementation - Information Gathering part 2",
          lesson_key: "devsecops-maturity-model-info-part-2",
          isDuplicate: true,
          lessonType: "video",
        },
      ],
    },
    {
      id: "sdlc-psirt",
      label: "SDLC - PSIRT",
      key: "sdlc-psirt",
      children: [
        {
          id: 896,
          key: "secure-development-lifecycle__b",
          label: "Secure Development Lifecycle",
          lesson_key: "secure-development-lifecycle",
          isDuplicate: true,
          lessonType: "video",
        },
        {
          id: 910,
          key: "dealing-with-vulnerabilities",
          label: "Dealing with Vulnerabilities",
          lesson_key: "dealing-with-vulnerabilities",
          lessonType: "video",
        },
      ],
    },
    {
      id: "sdlc-security-best-practices",
      label: "SDLC - Security Best Practices",
      key: "sdlc-security-best-practices",
      children: [
        {
          id: 278,
          key: "secure-coding-best-practices-part-1",
          label: "Secure Coding Best Practices: Part 1",
          lesson_key: "secure-coding-best-practices-part-1",
          lessonType: "video",
        },
        {
          id: 279,
          key: "secure-coding-best-practices-part-2",
          label: "Secure Coding Best Practices: Part 2",
          lesson_key: "secure-coding-best-practices-part-2",
          lessonType: "video",
        },
      ],
    },
    {
      id: "sdlc-security-requirements",
      label: "SDLC - Security Requirements",
      key: "sdlc-security-requirements",
      children: [
        {
          id: 896,
          key: "secure-development-lifecycle",
          label: "Secure Development Lifecycle",
          lesson_key: "secure-development-lifecycle",
          isDuplicate: true,
          lessonType: "video",
        },
        {
          id: 807,
          key: "security-requirements",
          label: "Security Requirements",
          lesson_key: "security-requirements",
          lessonType: "video",
        },
      ],
    },
    {
      id: "sdlc-security-testing",
      label: "SDLC - Security Testing",
      key: "sdlc-security-testing",
      children: [
        {
          id: 624,
          key: "devsecops-sast",
          label: "Static Application Security Testing (SAST)",
          lesson_key: "devsecops-sast",
          lessonType: "breakfix",
        },
        {
          id: 621,
          key: "devsecops-dast",
          label: "Dynamic Application Security Testing (DAST)",
          lesson_key: "devsecops-dast",
          lessonType: "breakfix",
        },
        {
          id: 816,
          key: "next-generation-appsec-tools",
          label: "Next Generation AppSec Tools",
          lesson_key: "next-generation-appsec-tools",
          lessonType: "video",
        },
      ],
    },
    {
      id: "sdlc-third-party-testing",
      label: "SDLC - Third-Party Testing",
      key: "sdlc-third-party-testing",
      children: [
        {
          id: 896,
          key: "secure-development-lifecycle",
          label: "Secure Development Lifecycle",
          lesson_key: "secure-development-lifecycle",
          isDuplicate: true,
          lessonType: "video",
        },
        {
          id: 803,
          key: "penetration-testing-and-bug-bounty",
          label: "Penetration Testing and Bug Bounty",
          lesson_key: "penetration-testing-and-bug-bounty",
          lessonType: "video",
        },
      ],
    },
    {
      id: "stride-methodology",
      label: "STRIDE Methodology",
      key: "stride-methodology",
      children: [
        {
          id: 797,
          key: "threat-modeling-process",
          label: "Threat Modeling Process",
          lesson_key: "threat-modeling-process",
          lessonType: "video",
        },
      ],
    },
    {
      id: "threat-modeling-process",
      label: "Threat Modeling Process",
      key: "threat-modeling-process",
      children: [
        {
          id: 774,
          key: "threat-modeling-basics",
          label: "Threat Modeling Basics",
          lesson_key: "threat-modeling-basics",
          lessonType: "video",
        },
      ],
    },
  ],
};

const artificialIntelligenceAndLargeLanguageModelsLessonsForTree = {
  id: "artificial-intelligence-and-large-language-models-lessons",
  key: "artificial-intelligence-and-large-language-models-lessons",
  label: "Artificial Intelligence and Large Language Models",
  children: [
    {
      id: "aillm-core-security-topics",
      label: "Core Security",
      key: "aillm-core-security-topics",
      children: [
        {
          id: 1172,
          key: "introduction-to-ai-llm-security",
          label: "Introduction to AI/LLM Security",
          lesson_key: "introduction-to-ai-llm-security",
          lessonType: "video",
        },
        {
          id: 900,
          key: "secure-development-leveraging-llms",
          label: "Secure Development Leveraging LLMs",
          lesson_key: "secure-development-leveraging-llms",
          lessonType: "video",
        },
        {
          id: 899,
          key: "governance-for-ai-llm-systems",
          label: "Governance for AI/LLM Systems",
          lesson_key: "governance-for-ai-llm-systems",
          lessonType: "video",
        },
      ],
    },
    {
      id: "aillm-excessive-agency",
      label: "Excessive Agency",
      key: "aillm-excessive-agency",
      children: [
        {
          id: 1170,
          key: "ai-llm-ea",
          label: "AI/LLM | Excessive Agency: Human in the Loop",
          lesson_key: "ai-llm-ea",
          lessonType: "breakfix",
        },
        {
          id: 1171,
          key: "ai-llm-ea-2",
          label: "AI/LLM | Excessive Agency: Prompt Security",
          lesson_key: "ai-llm-ea-2",
          lessonType: "breakfix",
        },
        {
          id: 1168,
          key: "ai-llm-insecure-plugin",
          label: "AI/LLM | Insecure Plugin Design",
          lesson_key: "ai-llm-insecure-plugin",
          lessonType: "breakfix",
        },
      ],
    },
    {
      id: "aillm-improper-output-handling",
      label: "Improper Output Handling",
      key: "aillm-improper-output-handling",
      children: [
        {
          id: 1169,
          key: "ai-llm-ioh",
          label: "AI/LLM | Improper Output Handling",
          lesson_key: "ai-llm-ioh",
          lessonType: "breakfix",
        },
        {
          id: 742,
          key: "application-and-plugin-security-for-ai-llm",
          label: "Application and Plugin Security For AI/LLM",
          lesson_key: "application-and-plugin-security-for-ai-llm",
          lessonType: "video",
        },
      ],
    },
    {
      id: "aillm-misinformation",
      label: "Misinformation",
      key: "aillm-misinformation",
      children: [
        {
          id: 1161,
          key: "ai-llm-over",
          label: "AI/LLM | Misinformation",
          lesson_key: "ai-llm-over",
          lessonType: "breakfix",
        },
      ],
    },
    {
      id: "aillm-model-theft",
      label: "Model Theft",
      key: "aillm-model-theft",
      children: [
        {
          id: 1022,
          key: "ai-llm-mt",
          label: "AI/LLM | Model Theft",
          lesson_key: "ai-llm-mt",
          lessonType: "breakfix",
        },
      ],
    },
    {
      id: "aillm-prompt-security",
      label: "Prompt Security",
      key: "aillm-prompt-security",
      children: [
        {
          id: 1008,
          key: "ai-llm-prompt-injection",
          label: "AI/LLM | Prompt Injection",
          lesson_key: "ai-llm-prompt-injection",
          lessonType: "breakfix",
        },
        {
          id: 1162,
          key: "ai-llm-prompt-leakage",
          label: "AI/LLM | Prompt Leakage",
          lesson_key: "ai-llm-prompt-leakage",
          lessonType: "breakfix",
        },
        {
          id: 1256,
          key: "ctf-ai-module-prompt-leak-1",
          label: "CTF AI Module | Prompt Leak: I",
          lesson_key: "ctf-ai-module-prompt-leak-1",
          lessonType: "breakfix",
        },
        {
          id: 1257,
          key: "ctf-ai-module-prompt-leak-2",
          label: "CTF AI Module | Prompt Leak: II",
          lesson_key: "ctf-ai-module-prompt-leak-2",
          lessonType: "breakfix",
        },
        {
          id: 1258,
          key: "ctf-ai-module-prompt-leak-3",
          label: "CTF AI Module | Prompt Leak: III",
          lesson_key: "ctf-ai-module-prompt-leak-3",
          lessonType: "breakfix",
        },
        {
          id: 1259,
          key: "ctf-ai-module-prompt-leak-4",
          label: "CTF AI Module | Prompt Leak: IV",
          lesson_key: "ctf-ai-module-prompt-leak-4",
          lessonType: "breakfix",
        },
      ],
    },
    {
      id: "aillm-sensitive-information-disclosure",
      label: "Sensitive Information Disclosure",
      key: "aillm-sensitive-information-disclosure",
      children: [
        {
          id: 1014,
          key: "ai-llm-sid",
          label: "AI/LLM | Sensitive Information Disclosure",
          lesson_key: "ai-llm-sid",
          lessonType: "breakfix",
        },
        {
          id: 901,
          key: "llm-enterprise-security",
          label: "LLM Enterprise Security",
          lesson_key: "llm-enterprise-security",
          lessonType: "video",
        },
      ],
    },
    {
      id: "aillm-supply-chain-vulnerabilities",
      label: "Supply Chain Vulnerabilities",
      key: "aillm-supply-chain-vulnerabilities",
      children: [
        {
          id: 1015,
          key: "ai-llm-scv",
          label: "AI/LLM | Supply Chain Vulnerabilities",
          lesson_key: "ai-llm-scv",
          lessonType: "breakfix",
        },
        {
          id: 743,
          key: "ai-llm-security-toolchain",
          label: "AI/LLM Security Toolchain",
          lesson_key: "ai-llm-security-toolchain",
          lessonType: "video",
        },
      ],
    },
    {
      id: "aillm-training-data-and-model-poisoning",
      label: "Training Data and Model Poisoning",
      key: "aillm-training-data-and-model-poisoning",
      children: [
        {
          id: 1200,
          key: "ai-llm-poison",
          label: "AI/LLM Training Data Poisoning",
          lesson_key: "ai-llm-poison",
          lessonType: "breakfix",
        },
        {
          id: 741,
          key: "data-science-and-engineering-for-ai-llm",
          label: "Data Science and Engineering for AI/LLM",
          lesson_key: "data-science-and-engineering-for-ai-llm",
          lessonType: "video",
        },
        {
          id: 739,
          key: "model-engineering-for-ai-llm",
          label: "Model Engineering for AI/LLM",
          lesson_key: "model-engineering-for-ai-llm",
          lessonType: "video",
        },
      ],
    },
    {
      id: "aillm-unbounded-consumption",
      label: "Unbounded Consumption",
      key: "aillm-unbounded-consumption",
      children: [
        {
          id: 1160,
          key: "ai-llm-mdos",
          label: "AI/LLM | Unbounded Consumption",
          lesson_key: "ai-llm-mdos",
          lessonType: "breakfix",
        },
      ],
    },
    {
      id: "aillm-vector-and-embedding-weaknesses",
      label: "Vector and Embedding Weaknesses",
      key: "aillm-vector-and-embedding-weaknesses",
      children: [
        {
          id: 1163,
          key: "ai-llm-vew",
          label: "AI/LLM | Vector and Embedding Weaknesses",
          lesson_key: "ai-llm-vew",
          lessonType: "breakfix",
        },
        {
          id: 1261,
          key: "ctf-ai-rag",
          label: "CTF AI Module | RAG",
          lesson_key: "ctf-ai-rag",
          lessonType: "breakfix",
        },
        {
          id: 1260,
          key: "ctf-ai-rag-hijack",
          label: "CTF AI Module | RAG Hijack",
          lesson_key: "ctf-ai-rag-hijack",
          lessonType: "breakfix",
        },
      ],
    },
  ],
};

export const combinedLessonsForTree: LessonNode[] = [
  secureCodingLessonsForTree,
  coreSecurityConceptsLessonsForTree,
  secureDevelopmentAndDesignLessonsForTree,
  artificialIntelligenceAndLargeLanguageModelsLessonsForTree,
];

// Submission progress steps
export const SUBMISSION_STEPS = {
  VALIDATING: { value: 25, label: "Validating data..." },
  CREATING_ROLE: { value: 50, label: "Creating path..." },
  CREATING_POLICY: { value: 75, label: "Creating assignment..." },
  CREATING_ASSIGNMENT: { value: 90, label: "Assigning to users..." },
  COMPLETE: { value: 100, label: "Complete!" },
};
